import React from 'react';

interface ServiceProfileAreasProps {
  areaLabels: string[];
}

export const ServiceProfileAreas: React.FC<ServiceProfileAreasProps> = ({ areaLabels }) => {
  if (!areaLabels.length) return null;
  return (
    <section className="grid gap-4 border-t border-brand-cloud pt-7 md:grid-cols-[minmax(0,0.28fr)_minmax(0,0.72fr)] md:gap-8">
      <h3 className="public-card-title">Areas serviced</h3>
      <div className="flex flex-wrap gap-x-3 gap-y-2 text-sm leading-6 text-brand-slate">
        {areaLabels.map((areaLabel) => (
          <span key={areaLabel} className="rounded-md bg-brand-mist px-2.5 py-1 text-brand-ink">
            {areaLabel}
          </span>
        ))}
      </div>
    </section>
  );
};
